export const APP_NAME = 'Simulasi Undian Berhadiah';

export const NAVBAR_ITEMS = [
  {
    value: 'Home',
    to: '/',
    icon: 'home',
    useExact: true,
  },
  {
    value: 'Undian Acak',
    icon: 'box',
    to: '/',
  },
  {
    value: 'Pertanyaan',
    icon: 'list',
    to: '/faq',
  },
  {
    value: 'Daftar',
    icon: 'list',
    to: '/list',
  },
];

export const SPONSORS = [
  {
    name: 'Prenges',
    url: 'https://www.prenges.com/',
    img: './images/logo-1.png',
  },
  {
    name: 'Aliyul Erfan',
    url: 'https://www.facebook.com/franks007/',
    img: './images/prenges.jpg',
  },
  {
    name: 'Fathur Chiko',
    url: 'https://www.facebook.com/fathurrahman6660',
    img: './images/fathur.jpg'
  },
];
